module.exports = __webpack_public_path__ + "img/13_26@3x.1c86b359.png";